import React, { useCallback, useEffect, useState } from 'react';
import { Input, Label, Card, CardBody, CardTitle, CardSubtitle, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip } from 'reactstrap';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import ContentLoader from 'react-content-loader';
import queryString from 'query-string';
import moment from 'moment';
import { saveLocale, getLocale } from '../transInit';
import { t } from 'ttag';
import { DateTimePicker, Localization } from 'react-widgets';
import momentLocalizer from 'react-widgets-moment';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import * as transInit from '../transInit';
import { Helmet } from 'react-helmet';
import SvgViewer from '../../../commons/SvgViewer';
import Countdown from './Countdown';
import StepperSection from './StepperSection';
import SuccessEmptyState from '../../../commons/SuccessEmptyState';
import EmptyState from '../../../commons/EmptyState';
import Services from './services';
import 'moment/locale/hu';
import { ProgressButton } from '../../../commons/ProgressButton';
import { CookieConsentStateContext } from '../../../commons/CookieConsent';
import TimeFormatter from '../../../commons/TimeFormatter';
import NumberFormatter from '../../../commons/NumberFormatter';

moment.locale('hu');
const localizer = new momentLocalizer(moment);

const CONSTANTS = {
  fizetesiModAzonositok: ['BAR'],
  FIZMOD_KOD_BARION: 'BAR'
};

const EventSeatsPage = (props) => {
  // constructor(props) {
  //   let momentLoc = moment();
  //   momentLoc.locale(transInit.getLocale());
  //   super(props);
    let momentLoc = moment();
    momentLoc.locale(transInit.getLocale());
    let body = document.body;
    let wrapper = document.getElementById('page-content');

    // wrapper.classList.add("page-content-public");
    body.classList.add('dark-theme');

    const [activeSectors, setActiveSectors] = useState([]);

    const [ state, setState ] = useState({
      modalDelete: false,
      nyugtaButtonLoading: false,
      // [1,2,3,4]
      bucket: [],
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      pageStatus: 'LOAD',
      // ['CANCELED', 'SUCCEEDED']
      redirectStatus: ['SUCCEEDED'],
      isConsentSet: false,
      currentStep: 1,
      buttonLoading: false,
      formNev: '',
      formEmail: '',
      formMegvasarlas: false,
      formFoglalas: false,
      formRot: '',
      formBarion: false,
      checkboxAdatvedelmi: false,
      redirectUrl: "http://192.168.2.179:8288/jegy/event/38c502a56828c5a3fa05be070f1637e2",
      adatvedelmiUrl: null,
      hirlevelUrl: null,
      modalNyugta: false,
      modalNyugtaText: '',
      event: {
        ecu: '',
        eru: '',
        cid: undefined,
        des: undefined,
        eid: undefined,
        end: undefined,
        lid: undefined,
        nam: undefined,
        res: undefined,
        sta: undefined,
        otl: undefined,
        epi: '',
        eri: '',
        cur: undefined,
      },
      layout: {
        pi3: '',
        bix: 0,
        bax: 0,
        areas: [],
        blocks: [],
        cod: undefined,
        hid: undefined,
        hna: undefined,
        lid: undefined,
        nam: undefined,
        str: {},
        texts: [],
        vad: undefined,
        vna: undefined
      },
      init: {
        sectors: [],
        now: '',
        pty: [],
        rot: []
      },
      tickets: [],
      rendeles: {
        gatewayUrl: '',
        rendeles: {
          rot: {},
        },
        rendelesadat: {
          jegyadatok: []
        }
      },
      rendelesPenznem: '',
    });

  /*
  componentWillMount() {
    if (document.querySelector("[name='description']")) {
      document.querySelector("[name='description']").remove();
    }
  }
  */


  // componentDidMount() {
  //   loadData();
  // }

  const setStepFour = useCallback((resP) => {
    if (resP && resP[0] && resP[0].Status) {
      setState({
        ...state,
        currentStep: 4,
        redirectStatus: resP[0].Status.toUpperCase()
      })
      // setState({
      //   currentStep: 4,
      //   redirectStatus: resP[0].Status.toUpperCase()
      // });
    }
  }, [])

  const loadData = () => {
    const {
      match
    } = props;
    setState({
      ...state,
      pageStatus: 'LOAD'
    })
    // setState({
    //   pageStatus: 'LOAD',
    // }, () => {
      Services.getEvent(eventId, CONSTANTS.fizetesiModAzonositok, (err, res) => {
        if (!err) {
          let paymentId = queryString.parse(search).paymentId;
          if (paymentId && paymentId !== '') {
            Services.GetPaymentState(paymentId, (errP, resP) => {
              if (!errP) {
                setState({
                  ...state,
                  event: res[0].event,
                  layout: res[0].layout,
                  init: res[0].init,
                  tickets: res[0].tickets,
                  pageStatus: 'DATA'
                });
                setStepFour(resP)
                // if (resP && resP[0] && resP[0].Status) {
                //   setState({
                //     currentStep: 4,
                //     redirectStatus: resP[0].Status.toUpperCase()
                //   });
                // }
                setState({
                  ...state,
                  event: res[0].event,
                  layout: res[0].layout,
                  init: res[0].init,
                  tickets: res[0].tickets,
                  pageStatus: 'DATA'
                });
                setStepFour(resP)
              }
            });
          } else {
            if (res[0].tickets && res[0].tickets.length == 1)
              setActiveSectors([res[0].tickets[0].tid]);
            setState({
              ...state,
              tickets: res[0].tickets,
              event: res[0].event,
              layout: res[0].layout,
              init: res[0].init,
              pageStatus: 'DATA'
            }, () => {
              // Create BP element on the window
              window["bp"] = window["bp"] || function () {
                (window["bp"].q = window["bp"].q || []).push(arguments);
              };
              window["bp"].l = 1 * new Date();

              // let scriptElementt = document.createElement("script");
              // let firstScriptt = document.getElementsByTagName("script")[0];
              // scriptElementt.type = 'text/javascript';
              // scriptElementt.innerText='// ' + res[0].layout.pi3
              // firstScriptt.parentNode.insertBefore(scriptElementt, firstScriptt);

              // // Insert a script tag on the top of the head to load bp.js
              // let scriptElement = document.createElement("script");
              // let firstScript = document.getElementsByTagName("script")[0];
              // // scriptElement.async = true;
              // scriptElement.src = 'https://pixel.barion.com/bp.js';
              // firstScript.parentNode.insertBefore(scriptElement, firstScript);

              // Send init event
              // console.log(window.bp)
              // window.bp('init', 'addBarionPixelId', res[0].layout.pi3);
              window.bp('init', 'addBarionPixelId', window['apiKey'])
              //  console.log('---')
              //  console.log(window.name)
              //  console.log(window)
              //  window.test();
              // window.bp('consent', 'grantConsent');
              // ifrm.name = script.substr(script.indexOf("BP-"), 16, 16);
              setState({
                ...state,
                barionPixelLoaded: true
              });
              // setState({
              //   barionPixelLoaded: true
              // });
            });
          }


          // console.log(queryString.parse(props.location.search).paymentId);
        } else {
          setState({
            ...state,
            pageStatus: 'NETW'
          });
          // setState({
          //   pageStatus: 'NETW'
          // }, () => {
          //   // console.log(props);
          //   // props.globals.route.navigate({
          //   //   pathname: `${props.globals.PUBLIC_URL}/timeout`,
          //   //   state: { eventId: match.params.eventId }
          //   // })
          //   // setTimeout(() => { window.location.href = state.event.eru }, 7000);
          // });
        }
      });
    // });
  }

  
  useEffect(() => {
    loadData();
  }, []);

  const renderPixelConsent = (value) => {
    if (!state.isConsentSet) {
      if (value.marketing === 0) {
        window.bp('consent', 'rejectConsent');
      } else {
        window.bp('consent', 'grantConsent');
      }
      setState({
        ...state,
        isConsentSet: true
      });
      // setState({
      //   isConsentSet: true
      // })
    }
    return '';
  }

  const handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    switch (name) {
      case 'formMegvasarlas':
        setState({
          ...state,
          formFoglalas: false,
          formPayment: null,
          [name]: value
        });
        // setState({
        //   formFoglalas: false,
        //   formPayment: null,
        //   [name]: value
        // });
        break;
      case 'formFoglalas':
        setState({
          ...state,
          formMegvasarlas: false,
          formPayment: null,
          [name]: value
        });
        // setState({
        //   formMegvasarlas: false,
        //   formPayment: null,
        //   [name]: value
        // });
        break;
      default:
        setState({
          ...state,
          [name]: value
        });
        // setState({
        //   [name]: value
        // });
    }
  }

  const handleRotChange = (e) => {
    const { target } = e;
    // const value = target.value;
    const { name } = target;

    setState({
      ...state,
      formRot: name
    });
    // setState({
    //   formRot: name
    // });
  }

  const getTicketTypeByTicketId = (ticketSector) => {
    let tickets = JSON.parse(JSON.stringify(state.tickets));
    let activeSectorsArray = JSON.parse(JSON.stringify(activeSectors));
    let result = -1;

    activeSectorsArray.forEach((sector) => {
      tickets.forEach((ticket) => {
        if ((sector === ticket.tid) && (ticket.sec === ticketSector)) {
          result = {
            sec: sector,
            pri: ticket.pri,
            nam: ticket.nam,
            cur: ticket.cur
          };
        }
      });
    });

    return result;
  }

  const isTicketInBucket = (tid, deletedTickets) => {
    let hasTalalat = false;
    deletedTickets.forEach((element) => {
      if (tid === element.tid) hasTalalat = true;
    });
    return hasTalalat;
  }

  const onTicketClick = (ticket, row, rowLabel, hasGroup, seatPrefix, seatSufix, blockPrefix) => {
    let isDelete = false;
    let blockIdx = 0;
    let layout = JSON.parse(JSON.stringify(state.layout));
    layout.blocks.forEach((block, idx) => {
      block.seats.forEach((seat) => {
        if (seat.tid === ticket.tid) {
          if (seat.new) isDelete = true;
          blockIdx = idx;
          seat.new = !seat.new;
        }
      });
    });

    if (hasGroup) {
      layout.blocks[blockIdx].seats.forEach((element) => {
        if (isDelete) {
          element.new = false;
        } else {
          element.new = true;
        }
      });
    }

    if (isDelete) {
      if (hasGroup) {
        let deletedTickets = [];
        layout.blocks.forEach((block) => {
          block.seats.forEach((seat) => {
            if (seat.tid === ticket.tid) {
              deletedTickets = block.seats;
            }
          });
        });
        let bucket = JSON.parse(JSON.stringify(state.bucket));
        let filteredBucket = bucket.filter((item, index) => {
          return !isTicketInBucket(item.sid, deletedTickets)
        });
        setState({
          ...state,
          bucket: filteredBucket,
          layout: layout
        });
        // setState(prevState => ({
        //   bucket: filteredBucket,
        //   layout: layout
        // }));
      } else {
        setState({
          ...state,
          bucket: state.bucket.filter(bucketItem => bucketItem.sid !== ticket.tid),
          layout: layout
        });
        // setState(prevState => ({
        //   bucket: prevState.bucket.filter(bucketItem => bucketItem.sid !== ticket.tid),
        //   layout: layout
        // }));
      }
    } else {
      if (getTicketTypeByTicketId(ticket.sec) === -1 ) {
        props.globals.addError('Ülőhely választáshoz jegytípus választása kötelező!')
      } else {
        seatPrefix = seatPrefix ? seatPrefix : '';
        seatSufix = seatSufix ? seatSufix : '';

        if (hasGroup) {
          let newTickets = [];
          layout.blocks.forEach(block => {
            block.seats.forEach(seat => {
              if (seat.tid === ticket.tid) {
                newTickets = block.seats;
              }
            });
          });
          let newDetailedTickets = [];
          newTickets.forEach((item) => {
            newDetailedTickets.push({
              rowLabel: rowLabel,
              lab: seatPrefix + item.lab + seatSufix,
              sid: item.tid,
              lbp: blockPrefix,
              tid: getTicketTypeByTicketId(item.sec).sec,
              pri: getTicketTypeByTicketId(item.sec).pri,
              nam: getTicketTypeByTicketId(item.sec).nam,
              cur: getTicketTypeByTicketId(item.sec).cur,
            })
          })
          setState({
            ...state,
            bucket: state.bucket.concat(newDetailedTickets),
            layout: layout
          });
          // console.log(newDetailedTickets)
          // setState(prevState => ({
          //   bucket: prevState.bucket.concat(newDetailedTickets),
          //   layout: layout
          // }));
        } else {
          setState({
            ...state,
            bucket: [...state.bucket,
              {
                rowLabel: rowLabel,
                lab: seatPrefix + ticket.lab + seatSufix,
                sid: ticket.tid,
                lbp: blockPrefix,
                tid: getTicketTypeByTicketId(ticket.sec).sec,
                pri: getTicketTypeByTicketId(ticket.sec).pri,
                nam: getTicketTypeByTicketId(ticket.sec).nam,
                cur: getTicketTypeByTicketId(ticket.sec).cur,
              }
            ],
            layout: layout
          });
        }
      }
    }
  }

  const renderEventError = () => {
    return (
      <div className="row" style={{ padding: 20 }}>
        <div className="wrapper col-md-8" style={{ padding: 20 }}>
          <p style={{ fontSize: '1.75rem', textAlign: 'center' }}>{t`Ez az esemény nem található!`}</p>
          <p style={{ fontSize: '1.1rem', textAlign: 'center' }}>{t`Rövidesen át lesz irányítva a főoldalra, vagy `}<a href={props.globals.public_url}>{t`kattintson ide`}</a> {t`az azonnali navigáláshoz.`}</p>
          <p style={{ fontSize: '1.1rem', textAlign: 'center' }}>{t`Elnézést kérünk a kellemetlenségért!`}</p>
        </div>
      </div>
    );
  }

  const renderSectors = () => {
    const {
      init,
    } = state;

    const sectors = init.sectors.map((item, idx) => {
      return item.use && (
        <React.Fragment key={idx}>
          <div className="col-md-12 mb-1" style={{ padding: 0 }}>
            <p style={{
              borderLeft: '8px solid #' + item.col,
              padding: 4,
              paddingLeft: 10,
              margin: 0
            }}><span>{('hu' === transInit.getLocale() ? item.nam : item.name ? item.name : item.nam) + ' (' }</span>
               <span>{t`szabad/összes`}</span>
               <span>{' - ' + item.caf + '/' + item.cap + '): '}</span>
            </p>
          </div>
          {renderTicketsByIDd(item.id, item.col, item.han, idx)}
        </React.Fragment>
      );
    });

    return sectors;
  }

  const renderPaymentTypes = () => {
    if (state.init && state.init.fizmod) {
      return (
        <React.Fragment>
          <p style={{ fontSize: '1.65rem' }}>{t`Fizetési mód megadása:`}</p>
          <div className="row">
            {renderPaymentTypeInputs()}
          </div>
          <p>* = {t`A mezők kitöltése kötelező`}</p>
        </React.Fragment>
      );
    }

    return <p>{t`Nincs választható fizetési mód!`}</p>;
  }

  const getConvenienceFeeString = (cop, cof, cur) => {
    let dij = cop ? (NumberFormatter.addSpacesToString(cop, NumberFormatter.OSSZEG) + '%') : '';
    dij += cop && cof ? ' + ' : '';
    dij += cof ? NumberFormatter.addSpacesToString(cof, NumberFormatter.OSSZEG) + ' ' + cur : '';

    return dij.replace('.',',');
  }

  const renderConvenienceFee = (item) => {
    if (!item.useconveniencefee || (!state.event.cof && !state.event.cop))
      return;

    let dij = getConvenienceFeeString(state.event.cop, state.event.cof, state.event.cur);

    if (getLocale() === 'en' && item.conveniencefeedescriptionen) {
      return (
        <div>
          <br />
          {item.conveniencefeedescriptionen.replace('$1', dij.trim())}
        </div>
      );
    } else if (item.conveniencefeedescription) {
      return (
        <div>
          <br />
          {item.conveniencefeedescription.replace('$1', dij.trim())}
        </div>
      );
    }
  }

  const renderPaymentTypeInputs = () => {
    return state.init.fizmod.map((fizmod) => {
      let formName = 'formPayment' + fizmod.kod;
      return (
        <div className="col-md-6" style={{ }}>
          <input
            name="formPayment"
            type="radio"
            id={formName}
            checked={parseInt(state.formPayment, 10) === fizmod.id}
            onChange={handleInputChange}
            value={fizmod.id}
          />
          <label htmlFor={formName}>{fizmod.nev}</label>
          <img src={process.env.PUBLIC_URL + '/img/' + fizmod.kod + '.png'} alt={fizmod.nev + ' logo'} />
          <br />
        </div>
      );
    });
  }


  const isNotEmpty = (data) => {
    if (data && data !== '') return true;
    return false;
  }

  const getCorrectTextColor = (hex) => {
    /*
    From this W3C document: http://www.webmasterworld.com/r.cgi?f=88&d=9769&url=http://www.w3.org/TR/AERT#color-contrast

    Color brightness is determined by the following formula:
    ((Red value X 299) + (Green value X 587) + (Blue value X 114)) / 1000

    I know this could be more compact, but I think this is easier to read/explain.

    */

    let threshold = 130; /* about half of 256. Lower threshold equals more dark text on dark background  */

    function cutHex(h) { return (h.charAt(0) === '#') ? h.substring(1, 7) : h; }
    function hexToR(h) { return parseInt((cutHex(h)).substring(0, 2), 16); }
    function hexToG(h) { return parseInt((cutHex(h)).substring(2, 4), 16); }
    function hexToB(h) { return parseInt((cutHex(h)).substring(4, 6), 16); }

    let hRed = hexToR(hex);
    let hGreen = hexToG(hex);
    let hBlue = hexToB(hex);

    let cBrightness = ((hRed * 299) + (hGreen * 587) + (hBlue * 114)) / 1000;
    if (cBrightness > threshold) { return '#000000'; } return '#ffffff';
  }

  const renderTicketsByIDd = (sectorId, sectorColor, isAccessible, sectorIdx) => {
    const {
      tickets
    } = state;

    const ticket = tickets.map((item, idx) => {
      if (item.sec === sectorId) {
        // console.log('LOG: ',  !activeSectors.includes(item.tid))
        if (!activeSectors.includes(item.tid)) {
          let newActiveSectors = JSON.parse(JSON.stringify(activeSectors));
          newActiveSectors[sectorIdx] = item.tid;
          const _clonedSectors = activeSectors;
        }
        return (
          <div className="col-md-4 col-sm-6 px-sm-1" key={item.tid} id="kartyatipuscard">
            <Card
              style={{
                backgroundColor: activeSectors.includes(item.tid) ? '#' + sectorColor : null,
                color: activeSectors.includes(item.tid) ? getCorrectTextColor(sectorColor) : null,
                cursor: 'pointer',
                marginTop: 0,
                marginBottom: 4
              }}
              onClick={() => {
                let newActiveSectors = JSON.parse(JSON.stringify(activeSectors));
                newActiveSectors[sectorIdx] = item.tid;
                setActiveSectors(newActiveSectors);
                // setState({
                //   activeSectors: newActiveSectors
                // })
              }}
            >
              <CardBody className='align-items-center row' style={{ paddingTop: 2, paddingBottom: 2 }}>
                <div className='col-8 mb-0 pr-0' style={{ textAlign: 'left' }}>
                  {item.nam + ' '}
                  {isAccessible && <i className="fa fa-wheelchair" aria-hidden="true" />}
                  {isNotEmpty(item.des) && (<i className="fa fa-info-circle pull-right" style={{ marginTop: 4 }} aria-hidden="true" id={'tickedcard-' + item.tid} />)}
                </div>
                <div className='col-4' style={{ textAlign: 'end' }}>{NumberFormatter.formatterSpaceOsszeg(item.pri) + ' ' + item.cur}</div>
              </CardBody>
            </Card>
            {isNotEmpty(item.des) && (
              <UncontrolledTooltip trigger='hover focus-visible' placement="top" target={'tickedcard-' + item.tid}>
                {item.des}
              </UncontrolledTooltip>
            )}
          </div>
        )
      }
    });

    return ticket;
  }

  const isEmptyOrNull = (data) => {
    if (!data || data === '') return true;
    return false;
  }

  const getPurchaseObj = () => {
    return {
      ste: state.currentStep,
      now: state.init.now,
      eid: state.event.eid,
      rid: state.event.rid,
      nam: state.formNev,
      ema: state.formEmail,
      seattickets: state.bucket,
      rot: (!state.formRot || state.formRot === '') ? null : state.formRot,
      pty: (state.formRot === 'ONLINE_VASARLAS') ? parseInt(state.formPayment, 10) : null,
      cns: !state.adatvedelmiUrl || state.checkboxAdatvedelmi,
      fizmodok: CONSTANTS.fizetesiModAzonositok,
    };
  }

  const toggleNyugtaModal = () => {
    setState({ ...state, modalNyugta: !state.modalNyugta, modalNyugtaText: '' });
  }

  const goToStepFive = useCallback(() => {
    if (currentStep === 4 && state.buttonLoading === false) {
      setTimeout(() => {
        if (!isEmptyOrNull(state.event.eru)) {
          window.location.replace(state.event.eru);
        }
      }, 7000);
    }
  }, [state.currentStep, state.buttonLoading])

  const rendelesFolytatas = () => {
    Services.sendPurchase(getPurchaseObj(), (err, res) => {
      if (!err) {
        if (state.formRot === 'ONLINE_VASARLAS' && state.formPayment) {
          let valasztottFizMod = state.init.fizmod.find(fizmod => fizmod.id === parseInt(state.formPayment, 10));

          // BARION ÁG
          if (valasztottFizMod && (valasztottFizMod.kod === CONSTANTS.FIZMOD_KOD_BARION)) {
            if ('fbq' in window) {
              window.fbq('track', 'Purchase', { currency: state.rendelesPenznem, value: state.bucket.reduce((a, o) => (a + o.pri), 0) });
            }
            window.location.replace(res[0].gatewayUrl);
          }
          // IDE JÖN A TÖBBI ÚJ FIZETÉSI ÁG IMPLEMENTÁCIÓ
          // ...
        } else {
          setState({
            ...state,
            buttonLoading: false,
            currentStep: 5
          });
          // setState({
          //   buttonLoading: false,
          //   currentStep: 5
          // }, () => {
          //   setTimeout(() => {
          //     if (!isEmptyOrNull(state.event.eru)) {
          //       window.location.replace(state.event.eru);
          //     }
          //   }, 7000);
          // });
          goToStepFive();
          if ('fbq' in window) {
            window.fbq('track', 'AddToWishlist');
          }
        }
      } else {
        setState({ ...state, buttonLoading: false });
      }
    });
  }

  const sumbitNyugtaWarning = () => {
    setState({
      ...state,
      nyugtaButtonLoading: true,
      modalNyugtaText: '',
    });
    // setState({ nyugtaButtonLoading: true });
    toggleNyugtaModal();
    rendelesFolytatas();
    // setState({ nyugtaButtonLoading: false });
    setState({
      ...state,
      nyugtaButtonLoading: false
    });
  }

    const {
      globals
    } = props;

    const {
      currentStep,
      formMegvasarlas,
      formFoglalas,
      formBarion,
      bucket,
      event,
      layout,
      init,
      formRot,
      redirectStatus,
      modalNyugtaText,
    } = state;

    moment.locale(transInit.getLocale());
    const { eventId } = useParams();
    const search = useSearchParams();
    return (
      <React.Fragment>
          <Localization date={localizer}>
        {state.event && (
          <Helmet>
            <title>{state.event.nam}</title>
            <meta name="description" content={state.event.des} />
            <meta name="title" content={state.event.nam} />
          </Helmet>
        )
        }
        {state.pageStatus !== 'NETW' && (
          <CookieConsentStateContext.Consumer>
            {value => (
              <div className="landing__section">
                <div className="container">
                  <div className="expanded__inner" style={{}}>
                    <h2 className="expanded__title subtitle">{t`JEGYVÁSÁRLÁS`}</h2>
                  </div>
                  <div className="container" style={{ paddingLeft: 0, paddingRight: 0 }}>
                    <div className="row justify-content-md-center">
                      <Countdown time={event.otl} eru={event.eru} rid={event.rid} eventId={eventId} />
                      <div className="col-md-3 d-none d-md-block">
                        {{
                          LOAD: (
                            <ContentLoader
                              height={500}
                              width={900}
                              speed={1}
                              primaryColor="#353535"
                              secondaryColor="#404040"
                            >
                              <rect x="20" y="15" rx="20" ry="20" width="300" height="450" />
                            </ContentLoader>
                          ),
                          DATA: (
                            (!isEmptyOrNull(state.event.ecu) && !isEmptyOrNull(state.event.eru)) && (
                              <img
                                src={state.event.eru + state.event.ecu}
                                alt="poster"
                                className="img-fluid"
                                style={{ width: '100%' }}
                              />
                            )
                          ),
                          NETW: (<span />),
                        }[state.pageStatus]}
                      </div>
                      <div className="col-md-9">
                        {{
                          LOAD: (
                            <ContentLoader
                              height={500}
                              width={1300}
                              speed={1}
                              primaryColor="#353535"
                              secondaryColor="#404040"
                            >
                              <rect x="20" y="17" rx="10" ry="10" width="840" height="66" />
                              <rect x="20" y="150" rx="10" ry="10" width="500" height="50" />
                              <rect x="20" y="250" rx="10" ry="10" width="500" height="50" />
                              <rect x="20" y="350" rx="10" ry="10" width="500" height="50" />
                            </ContentLoader>
                          ),
                          DATA: (
                            <React.Fragment>
                              <h3 style={{ marginBottom: 18 }}>{/*match.params.eventId*/}{event.nam}</h3>
                              <p style={{ color: '#a09696', fontSize: 18 }}>{layout.hna}</p>
                              <p><b>{t`Helyszín:`} </b> {layout.vna}{' '}{layout.vad}</p>
                              <p><b>{t`Időpont:`} </b> {event.sta && TimeFormatter.formatLLLL(event.sta)} </p>
                              <p><b>{t`Leírás:`} </b> {event.des} </p>
                              {/* <p>{event.epi} </p>
                              <p>{event.eri} </p> */}
                            </React.Fragment>
                          ),
                          NETW: (<span />),
                        }[state.pageStatus]}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="landing__section" style={{ marginTop: 0 }}>
                  <div className="container">
                    <div>
                      <StepperSection currentStep={currentStep}>
                        {{
                          1: (
                            <React.Fragment>
                              <div className="wrapper tickettype mb-0 mb-sm-1 pb-0 pb-sm-1" style={{ padding: 20 }}>
                                <p className="tickettype-card-title">{t`Jegytípus választása:`}</p>
                                <p>{t`Jegyvásárláshoz, illetve foglaláshoz kérjük, először válassza ki a jegy típusát, utána az ülőhelyet!`}</p>
                                <div className="row justify-content-center no-gutters" style={{ margin: 0, marginBottom: 4 }}>
                                  {renderSectors()}
                                </div>
                              </div>
                              <SvgViewer
                                pinch
                                zoomEnabled
                                data={layout}
                                szektorok={init.sectors}
                                szinek={{
                                  coa: init.coa,
                                  con: init.con,
                                  cop: init.cop
                                }}
                                onTicketClick={onTicketClick}
                                style={{ maxHeight: 320 }}
                              />
                              <div className="wrapper mt-0" style={{ padding: 20 }}>
                                <p style={{ fontSize: '1.2rem', marginBottom: 5 }}>{t`Választott jegyek:`}</p>
                                <div className="row no-gutters">
                                  {bucket.length > 0 ? bucket.map((item, index) => {
                                    return (
                                      <div className="col-md-12">
                                        <div className="select-ticket">
                                          <b>{t`Sor:`}</b><span>{' ' + (item.lbp ? item.lbp : '') + ' ' + item.rowLabel + ', '}</span>
                                          <b>{t`Szék:`}</b><span>{' ' + item.lab + ', '}</span>
                                          <b>{t`Jegytípus:`}</b><span>{' ' + item.nam + ', '}</span>
                                          <b>{t`Jegyár:`}</b><span>{' ' + NumberFormatter.formatterSpaceOsszeg(item.pri) + ' ' + item.cur}</span>
                                        </div>
                                      </div>
                                    )
                                  }) : <EmptyState hasImage title={t`Még nem választott jegyet!`} subtitle={t`Jegyválasztáshoz klikkeljen egy székre a helykiosztáson.`} />}
                                </div>
                              </div>
                            </React.Fragment>
                          ),
                          2: (
                            <div className="wrapper" style={{ padding: 20 }}>
                              <p style={{ fontSize: '1.65rem' }}>{t`Személyes adatok megadása:`}</p>
                              <RFForm id="my-form">
                                <div>
                                  <Label for="formNev">{t`Név: *`}</Label>
                                  <RFField name="formNev" id="formNev" value={state.formNev} autoComplete="off" onChange={handleInputChange} required />
                                </div>
                                <div>
                                  <Label for="formEmail">E-mail: *</Label>
                                  <RFField name="formEmail" id="formEmail" value={state.formEmail} autoComplete="off" onChange={handleInputChange} required />
                                </div>
                              </RFForm>
                              <p>* = {t`A mezők kitöltése kötelező`}</p>
                            </div>
                          ),
                          3: (
                            <div className="wrapper" style={{ padding: 20 }}>
                              <p style={{ fontSize: '1.65rem' }}>{t`Rendelés típusa:`}</p>
                              <RFForm id="my-form">
                                <div className="row justify-content-center" style={{ margin: 0 }}>
                                  {state.init.rot.map((item, idx) => {
                                    return (
                                      <div className="col-md-6" key={idx}>
                                        <label htmlFor={item.name} id="rendelestipus-radio-label">
                                          <div
                                            style={{
                                              border: '1px solid #bbbaba', 
                                              marginTop: 6,
                                              marginBottom: 6,
                                              padding: 10
                                            }}
                                          >
                                            <Input
                                              key={item.name}
                                              name={item.name}
                                              type="radio"
                                              id={item.name}
                                              checked={formRot === item.name}
                                              onChange={handleRotChange}
                                            />
                                            <div style={{ marginBottom: 20 }} id='post-rendelestipus-radio-div'>
                                            {getLocale() === 'en' ? item.publiccaptionen : item.publiccaption}
                                            </div>
                                            <br />
                                            {getLocale() === 'en' ? item.descriptionen : item.description}
                                            <br />
                                            {renderConvenienceFee(item)}
                                          </div>
                                        </label>
                                      </div>
                                    );
                                  })}
                                </div>
                              </RFForm>
                              {formRot === 'ONLINE_VASARLAS' && renderPaymentTypes()}
                            </div>
                          ),
                          4: (
                            <div className="wrapper" style={{ padding: 20 }}>
                              <p style={{ fontSize: '1.65rem' }}>{t`Áttekintés és véglegesítés:`}</p>
                              <p style={{ fontSize: '1.4rem' }}>{t`Rendelés adatai:`}</p>
                              <div className="container">
                                <p><strong>{t`Rendelésszám: `}</strong>{state.rendeles.rendelesadat.rendelesSorszam}</p>
                                <p><strong>{t`Rendelő neve: `}</strong>{state.rendeles.rendelesadat.rendeloNev}</p>
                                <p><strong>{t`Rendelő e-mail címe: `}</strong>{state.rendeles.rendelesadat.rendeloEmail}</p>
                                <div className="row">
                                  <div id="no-more-tables" style={{ width: '100%' }}>
                                    <table className="col-sm-12 table-reservation table-striped table-condensed cf">
                                      <thead className="cf">
                                        <tr>
                                          <th>{t`Jegytípus`}</th>
                                          <th>{t`Ár`}</th>
                                          {state.rendeles.rendeles.rot.useconveniencefee && (state.event.cof || state.event.cop) && (<th>{t`Kényelmi díj`}</th>)}
                                          <th>{t`Hely`}</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {state.rendeles.rendelesadat.jegyadatok.map((item) => {
                                          let ticket = state.tickets.find(x => item.szektorId === x.sec && item.jegyTipusId === x.tid);
                                          return (
                                            <tr key={item.helyId}>
                                              <td data-title={t`Jegytípus`}>{item.jegyTipus}</td>
                                              <td data-title={t`Ár`}>{NumberFormatter.formatterSpaceOsszegPenznem(ticket.pri, null, item.jegyPenznem)}</td>
                                              {state.rendeles.rendeles.rot.useconveniencefee && (state.event.cof || state.event.cop) && (
                                                <React.Fragment>
                                                  <td data-title={t`Kényelmi díj`}>
                                                    {NumberFormatter.formatterSpaceOsszegPenznem(item.kenyelmiDij, null, item.jegyPenznem)}
                                                    {state.event.cop && <i className="fa fa-info-circle" style={{ marginTop: 4, paddingLeft: 10 }} aria-hidden="true" id={'conveniencefee-' + item.id} />}
                                                  </td>
                                                  {state.event.cop &&
                                                    <UncontrolledTooltip trigger='hover focus-visible' placement="top" target={'conveniencefee-' + item.id}>
                                                      {getConvenienceFeeString(state.event.cop, state.event.cof, item.jegyPenznem)}
                                                    </UncontrolledTooltip>
                                                  }
                                                </React.Fragment>
                                              )}
                                              <td data-title={t`Hely`}>{item.jegyHely}</td>
                                            </tr>
                                          );
                                        })
                                       }
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                                <p style={{ fontSize: 18 }}>{t`Összesen fizetendő: `}<strong>
                                {NumberFormatter.formatterSpaceOsszegPenznem(state.rendeles.rendelesadat.rendelesOsszeg, null, state.rendeles.rendelesadat.rendelesOsszegPenznem)}
                                  </strong></p>
                              </div>
                            </div>
                          ),
                          5: (
                            <div className="wrapper" style={{ padding: 20 }}>
                              <p style={{ fontSize: '1.65rem' }}>{t`Sikeres foglalás!`}</p>
                              {{
                                CANCELED: (
                                  <SuccessEmptyState title="Sikertelen vásárlás" subtitle=":(" />
                                ),
                                SUCCEEDED: (
                                  <div className="empty-state animated fadeIn">
                                    <img
                                      src={process.env.PUBLIC_URL + '/img/mail-sent.svg'}
                                      className="img-fluid"
                                      alt="img-avatar"
                                    />
                                    <h3>{t`Sikeres megrendelés!`}</h3>
                                    <p>{t`Az emailt elküldtük az Ön által megadott címre.`}</p>
                                    <p>{t`Rövidesen át lesz irányítva a főoldalra!`}</p>
                                  </div>
                                ),
                              }[state.redirectStatus]}
                            </div>
                          )
                        }[currentStep]}
                      </StepperSection>
                    </div>
                    {currentStep === 2
                      ? (
                        <div className="container">
                          <div className="row float-right">
                            <div className="col-md-12" style={{ marginBottom: 16, zIndex: 100 }}>
                              {state.adatvedelmiUrl ? (
                                <RFForm>
                                  <RFField
                                    type="checkbox"
                                    id="checkboxAdatvedelmi"
                                    name="checkboxAdatvedelmi"
                                    value={state.checkAdatvedelmi}
                                    onChange={handleInputChange}
                                    styleCheckbox={{ marginTop: 5 }}
                                  />
                                  <div style={{ marginLeft: 22 }}>{t`Elolvastam és elfogadom az `} <a target="_blank" href={state.adatvedelmiUrl}>{t`Adatvédelmi és jogi nyilatkozatot`} </a></div>
                                </RFForm>
                              ) : <div /> }
                            </div>
                          </div>
                          {state.hirlevelUrl ? (
                            <div className="row float-right col-md-12" style={{ marginBottom: 26, zIndex: 100, "fontWeight": "bold" }}>
                              <a target="_blank" href={state.hirlevelUrl}>{t`Feliratkozás hirlevélre`} </a>
                            </div>
                          ) : <div /> }
                        </div>
                      ) : <div />
                    }
                  </div>
                </div>
                <div className="container">
                  <div className="row" style={{ margin: 0 }}>
                    <div className="col-md-12" style={{ padding: 0, marginBottom: 16 }}>
                      {currentStep < 5 && (
                        <button
                          type="button"
                          className="search-button-style btn btn-secondary float-right"
                          disabled={state.buttonLoading}
                          onClick={() => {
                            switch (state.currentStep) {
                              case 1:
                                setState({ ...state, buttonLoading: true });
                                Services.sendPurchase(getPurchaseObj(), (err, res) => {
                                  if (!err) {
                                    let event1 = JSON.parse(JSON.stringify(state.event));
                                    event1.rid = res[0].rendeles.rid;

                                    bucket.forEach(bucketItem => {
                                      let seat = res[0].rendeles.seattickets.find(x => bucketItem.sid === x.sid && bucketItem.tid === bucketItem.tid);
                                      bucketItem.id = seat && seat.id;
                                    });

                                    setState({
                                      ...state,
                                      adatvedelmiUrl: res[0].adatvedelmiurl,
                                      hirlevelUrl: res[0].hirlevelurl,
                                      event: event1,
                                      buttonLoading: false,
                                      currentStep: 2
                                    });
                                  } else {
                                    setState({ ...state, buttonLoading: false });
                                  }
                                });
                                break;
                              case 2:
                                setState({ ...state, buttonLoading: true });
                                Services.sendPurchase(getPurchaseObj(), (err, res) => {
                                  if (!err) {
                                    setState({
                                      ...state,
                                      buttonLoading: false,
                                      currentStep: 3
                                    });
                                  } else {
                                    setState({ ...state, buttonLoading: false });
                                  }
                                });
                                break;

                              case 3:
                                setState({ ...state, buttonLoading: true });
                                Services.sendPurchase(getPurchaseObj(), (err, res) => {
                                  if (!err) {
                                    setState({
                                      ...state,
                                      rendeles: res[0],
                                      buttonLoading: false,
                                      currentStep: 4,
                                      rendelesPenznem: res[0].rendelesadat && res[0].rendelesadat.rendelesOsszegPenznem
                                    });
                                  } else {
                                    setState({ ...state, buttonLoading: false });
                                  }
                                });
                                break;
                              case 4:
                                setState({ ...state, buttonLoading: true });
                                if (state.formRot === 'ONLINE_VASARLAS') {
                                  Services.checkNyugtaBizonylatAndLimit(state.event.rid, (err, res) => {
                                    if (!err) {
                                      if (res[0] && (res[0].hiba === 'ceg' || res[0].hiba === 'bizonylat' || res[0].hiba === 'limit')) { // ceg || bizonylat || limit
                                        setState({ ...state, buttonLoading: false, modalNyugta: true, modalNyugtaText: res[0].hiba });
                                      } else {
                                        rendelesFolytatas();
                                      }
                                    } else {
                                      setState({ ...state, buttonLoading: false });
                                    }
                                  });
                                } else {
                                  rendelesFolytatas();
                                }
                                break;

                              default:
                                break;
                            }
                          }}
                        >
                          {state.currentStep === 4 ? ( state.formRot === 'ONLINE_FOGLALAS' ?  t`Lefoglalás ` : t`Tovább a fizetéshez`) : t`Tovább `}
                          { state.buttonLoading && (
                            <div className="spinner-border spinner-border-sm" role="status" style={{ marginBottom: 2, marginLeft: 5 }}>
                              <span className="sr-only">Loading...</span>
                            </div>
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                {(state.barionPixelLoaded && value.isSet === 1) && (
                  <React.Fragment>
                    {renderPixelConsent(value)}
                    <img height="1" width="1" style={{ display: 'none' }} alt="Barion Pixel" src={'https://pixel.barion.com/a.gif?ba_pixel_id=' + window['apiKey'] + '&ev=contentView&noscript=1'} />
                  </React.Fragment>
                )}
              </div>
            )}
          </CookieConsentStateContext.Consumer>
        )}
        <Modal
          isOpen={state.modalNyugta}
          toggle={toggleNyugtaModal}
          backdrop="static"
          style={{
            borderRadius: '12px',
            boxShadow: 'unset',
            borderTop: '4px solid var(--elsodleges-szin)',
            background: 'var(--szurke-tartalom-hatter-szin)',
            color: 'var(--default-font-szin)'
          }}
          contentClassName="nyugtaModalContentClass"
        >
          <ModalHeader style={{
            background: 'var(--szurke-tartalom-hatter-szin)',
            color: 'var(--default-font-szin)',
            textAlign: 'center',
            borderRadius: '10px 10px 0px 0px'
          }}
          >
            {state.modalNyugtaText === 'limit' && 
              <p style={{ background: 'var(--szurke-tartalom-hatter-szin)', color: 'var(--default-font-szin)', fontSize: '1.65rem' }}>{t`Figyelmeztetés`}</p>
            }
            <p style={{ background: 'var(--szurke-tartalom-hatter-szin)', color: 'var(--default-font-szin)' }}>
              {state.modalNyugtaText === 'limit' && t`A vásárlásról az összeg miatt nyugta nem állítható ki, az erről szóló számlát kérje a szolgáltatótól!`}
              {(state.modalNyugtaText === 'ceg' || state.modalNyugtaText === 'bizonylat') && t`Fizetés nem kezdeményezhető, kérjük vegye fel a kapcsolatot a szolgáltatóval!`}
            </p>
          </ModalHeader>
          <ModalFooter
            style={{
              background: 'var(--szurke-tartalom-hatter-szin)',
              color: 'var(--default-font-szin)'
            }}
          >
            {state.modalNyugtaText === 'limit' &&
              <React.Fragment>
                <button
                  type="button"
                  className="search-button-style btn btn-secondary float-right"
                  disabled={state.nyugtaButtonLoading}
                  onClick={sumbitNyugtaWarning}>{t`Tovább a fizetéshez`}
                  { state.nyugtaButtonLoading && (
                    <div className="spinner-border spinner-border-sm" role="status" style={{ marginBottom: 2, marginLeft: 5 }}>
                      <span className="sr-only">Loading...</span>
                    </div>
                  )}
                </button>
                <button type="button" className="search-button-style btn btn-secondary float-right" disabled={state.nyugtaButtonLoading} onClick={toggleNyugtaModal}>{t`Mégsem`}</button>
              </React.Fragment>
            }
            {(state.modalNyugtaText === 'ceg' || state.modalNyugtaText === 'bizonylat') &&
              <button type="button" className="search-button-style btn btn-secondary float-right" disabled={state.nyugtaButtonLoading} onClick={toggleNyugtaModal}>{t`Bezárás`}</button>
            }
          </ModalFooter>
        </Modal>
        </Localization>
      </React.Fragment>
    );
  }

export default EventSeatsPage;